import React from "react";
import { motion } from "framer-motion";
import { ArrowDownRight, MapPin } from "lucide-react";

const HERO_BG =
  "https://images.unsplash.com/photo-1696536823512-79d724454616?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxhdGhsZXRlJTIwdHJhaW5pbmclMjBhZ2lsaXR5JTIwc3BlZWQlMjB0cmFja3xlbnwwfHx8fDE3Nzc2Njc1NTN8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative min-h-screen w-full overflow-hidden hero-vignette"
      data-testid="hero-section"
    >
      <div
        className="absolute inset-0 bg-center bg-cover"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-[#0A0A0A]/70" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/40 via-transparent to-[#0A0A0A]" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 pt-40 md:pt-48 pb-24 min-h-screen flex flex-col justify-between">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-5xl"
        >
          <div className="flex items-center gap-3 mb-8" data-testid="hero-location-tag">
            <span className="w-8 h-px bg-[#E5B43A]" />
            <MapPin size={14} className="text-[#E5B43A]" />
            <span className="text-xs font-bold tracking-[0.3em] uppercase text-zinc-300">
              Houston · All Fitness Levels Invited
            </span>
          </div>

          <h1 className="font-display text-[14vw] md:text-[10vw] leading-[0.85] tracking-tighter text-white">
            GAIN<br />
            <span className="text-[#E5B43A]">TIME</span><br />
            FITNESS.
          </h1>

          <p className="mt-8 md:mt-10 max-w-xl text-base md:text-lg text-zinc-300 leading-relaxed">
            Online coaching built in Houston. Engineered for every athlete — from
            the 50-yard dash to the 5k finish line. Speed. Agility. Body
            mechanics. Recovery. Zero excuses.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-3 bg-[#E5B43A] text-black font-bold uppercase tracking-widest px-8 py-4 text-sm hover:bg-white hover:text-[#0A0A0A] transition-colors duration-300"
              data-testid="hero-cta-start"
            >
              Start Training <ArrowDownRight size={18} />
            </a>
            <a
              href="#services"
              className="inline-flex items-center justify-center gap-3 border border-zinc-700 text-white font-bold uppercase tracking-widest px-8 py-4 text-sm hover:border-[#E5B43A] hover:text-[#E5B43A] transition-colors duration-300"
              data-testid="hero-cta-services"
            >
              Explore Services
            </a>
          </div>
        </motion.div>

        <div className="hidden md:grid grid-cols-4 gap-8 pt-16 border-t border-zinc-800/70">
          {[
            { k: "100+", v: "Athletes Trained" },
            { k: "12 YRS", v: "Coaching Experience" },
            { k: "24/7", v: "Online Accessibility" },
            { k: "HOU", v: "Base of Operations" },
          ].map((s, i) => (
            <div key={i} data-testid={`hero-stat-${i}`}>
              <div className="font-display text-3xl md:text-4xl text-white">{s.k}</div>
              <div className="text-xs tracking-[0.2em] uppercase text-zinc-500 mt-2">{s.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
